import React, { memo, useState } from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import arrowSvg from '../../../assets/images/arrow.svg';

const StyledFlexRow = styled.div`
  display: flex;
  position: relative;
  flex-direction: row;
  align-items: center;
  width: max-content;
`;

const StyledRectangle = styled.div`
  height: 36px;
  width: 81px;
  position: absolute;
  z-index: 0;
  background-color: ${props => props.bgColor};
  -webkit-transition: width 0.4s;
  transition: width 0.4s;
  &.hover {
    width: 105%;
  }
`;

const StyledArrow = styled.img`
  height: 12px !important;
  width: 20px !important;
  align-self: center;
  margin-left: 15px;
  color: #fff;
  z-index: 2;
  filter: invert(1) sepia(1) saturate(0.1);
`;

const StyledText = styled.p`
  height: 27px;
  color: ${props => props.textColor};
  font-size: 20px;
  font-weight: 900;
  letter-spacing: 0.15px;
  font-family: AvenirMedium;
  line-height: 27px;
  margin: 0;
  z-index: 1;
  margin-left: 15px;
  white-space: nowrap;
  &:hover {
    text-decoration: none !important;
  }
`;

const StyledLink = styled(Link)`
  text-decoration: none !important;
  color: unset;
  width: max-content;
  &:hover {
    color: unset;
  }
`;

const CustomButtonComponent = ({ text, to, bgColor, textColor }) => {
  // const child = useRef(null);
  const [hoverState, setHoverState] = useState(false);
  const toggleHover = () => {
    setHoverState(!hoverState);
  };
  return (
    <StyledLink to={to}>
      <StyledFlexRow onMouseEnter={toggleHover} onMouseLeave={toggleHover}>
        <StyledRectangle
          className={hoverState ? 'hover' : ''}
          bgColor={bgColor}
        />
        <StyledText textColor={textColor}>{text}</StyledText>
        <StyledArrow src={arrowSvg} />
      </StyledFlexRow>
    </StyledLink>
  );
};

const CustomButton = memo(CustomButtonComponent);

CustomButton.defaultProps = {
  text: 'Read More',
  to: '',
  bgColor: 'white',
  textColor: '#1d1d1d'
};

CustomButton.propTypes = {
  text: PropTypes.string,
  to: PropTypes.string,
  bgColor: PropTypes.string,
  textColor: PropTypes.string
};

export { CustomButton };
